import { useEffect, useState } from 'react';

import { useUserHasSeen } from 'Modules/userLocalStorage';
import NewFeaturePromotion, {
  Props as BannerProps,
} from '@classify/react-marketing-components/NewFeaturePromotion';

interface Props extends BannerProps {
  userId: string | number;
  storageKey: string;
  shouldSeeBanner?: boolean;
}

const NewFeatureBanner = ({ userId, storageKey, shouldSeeBanner, ...otherProps }: Props) => {
  const { hasSeen: hasSeenFeature, setSeen } = useUserHasSeen(storageKey, userId, {
    shouldPreventAutoSeen: true,
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (hasSeenFeature === false && shouldSeeBanner !== false) {
      setIsOpen(true);
    }
  }, [hasSeenFeature, shouldSeeBanner]);

  const handleClose = () => {
    setSeen();
    setIsOpen(false);
  };

  return <NewFeaturePromotion isOpen={isOpen} onClose={handleClose} {...otherProps} />;
};

export default NewFeatureBanner;
